import { render, staticRenderFns } from "./ProgramCard.vue?vue&type=template&id=f1780c14&scoped=true&"
import script from "./ProgramCard.vue?vue&type=script&lang=ts&"
export * from "./ProgramCard.vue?vue&type=script&lang=ts&"
import style0 from "./ProgramCard.vue?vue&type=style&index=0&id=f1780c14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1780c14",
  null
  
)

export default component.exports